module.exports = __webpack_public_path__ + "static/media/team-member-05.2283ad00.jpg";